module.exports = __webpack_public_path__ + "static/media/sq3.3b61f3e7.jpg";